import _ from 'lodash'
export default {
  props: [],
  data() {
    return {}
  },
  computed: {},
  methods: {
    createIdAndKey(item) {
      const config = item.config
      // 使用组件类型+时间戳 为ID
      config.formId = `${_.toLower(item.typeId)}${new Date().getTime()}`
      config.renderKey = `${config.formId}${+new Date()}` // 改变renderKey后可以实现强制更新组件
      item.vModel = `${config.formId}`
      return item
    }
  }
}
